import React from 'react';

/* eslint-disable */
export const DISCLAIMER = (
  <>
    To help the government fight the funding of terrorism and money laundering
    activities, Federal law requires all financial institutions to obtain, verify,
    and record information that identifies each person who opens an account. What
    this means for you: When you open an account, we will ask for your name, address,
    date of birth, and other information that will allow us to identify you.
    We may also ask to see your driver&apos;s license or other identifying documents.
  </>
);
